module.exports = "https://www.gc-qa.gnp.com.mx/894ef9b02e1e25cbb08335947a366255.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cuenta-icono.svg
// module id = 1812
// module chunks = 0